import React from 'react';
import './RadiusInput.scss';
import { ReactComponent as RadiusIcon } from '../../assets/icons/new/search/radius.svg';
import { FormattedMessage } from 'react-intl';
import { Input, EInputType } from '@repo/apg-ui';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as ArrowDownBlackIcon } from '../../assets/icons/arrow-down-blcak.svg';

interface Props {
  radius: any;
  setRadius: any;
  radiusUnit: any;
  setRadiusUnit: any;
}

export const RADIUS_UNIT_TYPE = {
  KILO_METERS: 'km',
  METERS: 'm',
};

export const RadiusInput = (props: Props) => {
  return (
    <div
      className='d-flex align-items-center radius-input'
      onClick={(e) => {
        // we need it to prevent onFocus call in the ReactTags base component
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className='d-flex align-items-center justify-content-center'>
        <RadiusIcon className='radius-icon' />
        <div className='font-14 font-bold ps-3 pe-3'>
          <FormattedMessage id='ec.search.radius' defaultMessage='Radius' />
        </div>
      </div>
      <div className='radius-wrapper'>
        <Input
          inputType={EInputType.Text}
          type={'number'}
          min={1}
          max={props.radiusUnit === RADIUS_UNIT_TYPE.KILO_METERS ? 99 : 9999}
          value={props.radius}
          onChange={(name, value) => {
            props.setRadius(Number(value));
          }}
          inputWrapperClass='radius-input-wrapper'
          id='radiusInput'
          label='Radius Input'
        />
        <Dropdown className='download-toggle' align='end'>
          <Dropdown.Toggle className='button mt-0 basicLink svg-fill fw-bold' variant=''>
            <div className='download-toggle-content'>
              <span className='text-black'>{props.radiusUnit}</span>
              <ArrowDownBlackIcon className='arrow ms-2' />
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                props.setRadiusUnit(RADIUS_UNIT_TYPE.KILO_METERS);
              }}
            >
              <div className='text-black'>
                <FormattedMessage id='ec.search.kilometers' defaultMessage='Kilometer' />
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                props.setRadiusUnit(RADIUS_UNIT_TYPE.METERS);
              }}
            >
              <div className='text-black'>
                <FormattedMessage id='ec.search.meters' defaultMessage='Meter' />
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
